import { WorkflowQuestionConfig } from '@gripp/shared-logic';
import { FC } from 'react';

/**
 * How deep into nested routines this question sits. The sheet expands a nested
 * routine one level (`depth` 1) and prints only the nested routine's title
 * below that, so a routine chain can never make the form unbounded.
 */
export const MAX_NESTED_PRINT_DEPTH = 1;

export type RoutinePrintQuestionProps = {
  config: WorkflowQuestionConfig;
  depth: number;
};

/**
 * Renders only the answer area. The number, question text and required marker
 * are drawn by `PrintQuestionBlock`, so a single-question routine (Counter,
 * Status, QuickConfirm) can reuse the same renderer without a heading.
 */
export type RoutinePrintQuestion = FC<RoutinePrintQuestionProps>;
